let forms = {
   filter_customers: {
      icon: 'fa fa-university',
      title: 'Search Account',
      subtitle: 'Provide Account Details',
      forms: [
         { type: "text", form_type: "email", class: "col-md-5 col-lg-4 col-xl-3", validation: "min:3|max:200|email", placeholder: "Filter By Email", model: "email", label: "Email",hide_label: true },
         { type: "datepicker", form_type: "daterange", format: "dd-MM-yyyy", placement: "bottom-end", class: "col-md-5 col-lg-4 col-xl-3", validation: "", placeholder: "Filter By Date Created", model: "date", label: "Date",hide_label: true },
         { type: 'button', btnClass: 'btn-long btn-primary', class: 'col-md-3 col-lg-2', model: 'submit', label: 'Search'}
      ]
   },
}

let tables = {
   customer: {
      props: {
         icon: 'fa fa-users',
         title: 'Customers',
         border: true,
         'max-height': 500,
         'show-summary': false,
         search_fields: ['names', 'email', 'referal_code', ],
         columns: [
            { type: 'selection', width: 60, align: 'center' },
            { type: 'index', width: 60, align: 'center' },
            { title: "Referal Code", key: "referal_code", width: 200, align: 'right' },
            { title: "Names", key: "names", minWidth: 250 },
            { title: "Email", key: "email", minWidth: 250 },
         ],
         actions: [
            { type: 'menu', title: 'View', event: 'view', allow_multiple: false },
            { type: 'menu', title: 'Customer Data', event: 'customer:view', icon: 'fa-user-clock', allow_multiple: false },
         ]
      },
   },
}

export default {
   forms: utils.generateAllFormData(forms),
   tables
}